import { AllocationViewUliErpInformationModel, AllocationViewUliParty } from '../../models/allocation-view-list.model';
import { UliActivityType, UliStatus } from '../../../../../../common/constants';

export class AllocationCalendarUliInfo {
  uli: string;
  type: UliActivityType;
  load: string;
  origin: string;
  status: UliStatus;
  parties: AllocationViewUliParty[];
  erpInformation: AllocationViewUliErpInformationModel;
  compartmentId: number;
  leadUli: boolean;
  numberOfHu: number;
}
